module.exports = __webpack_public_path__ + "img/img2.9a7f364f.jpg";